import React from "react";

import { formatPrice } from "@app/scripts/utils";

import type { Cart } from "@app/scripts/types";

type Props = {
  cart: Cart | null;
  freeShipping?: number;
  shippingHeading?: string;
  shippingHeadingUnder?: string;
};

export const CartFreeShipping: React.FC<Props> = ({ cart, freeShipping, shippingHeading, shippingHeadingUnder }) => {
  const priceUntilFreeShipping =
    cart && freeShipping ? formatPrice(freeShipping - cart.items_subtotal_price / 100) : null;
  const hasFreeShipping = cart && freeShipping && freeShipping <= cart.items_subtotal_price / 100;
  const freeShippingBarWidth =
    cart && freeShipping ? Math.min((cart.items_subtotal_price / 100 / freeShipping) * 100, 100) : null;

  const strings = {
    shippingHeading: shippingHeading || "You’re receiving free standard shipping.",
    shippingHeadingUnder: priceUntilFreeShipping
      ? shippingHeadingUnder?.replace("{price}", priceUntilFreeShipping || "") ||
        `You’re <strong>${priceUntilFreeShipping} away</strong> from free standard shipping.`
      : "",
  };

  return freeShipping ? (
    <div className={`cart__free-shipping text-sm ${hasFreeShipping ? "active" : ""}`}>
      <div className="cart__free-shipping__message">
        {hasFreeShipping ? (
          <ui-icon width="12" height="12" name="icon-check-large"></ui-icon>
        ) : (
          <>
            <ui-icon width="16" height="16" name="icon-truck"></ui-icon>
          </>
        )}
        {hasFreeShipping ? (
          <span>{strings.shippingHeading}</span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: strings.shippingHeadingUnder }} />
        )}
      </div>
      <div className="cart__free-shipping-bar">
        <span style={{ width: `${freeShippingBarWidth}%` }} />
      </div>
    </div>
  ) : null;
};
